/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One row per segment: a label in the first column and a numeric value in the second, comma-, tab- or space-separated.`)
};

const es_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila por segmento: una etiqueta en la primera columna y un valor numérico en la segunda, separados por coma, tabulación o espacio.`)
};

const de_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile pro Segment: eine Bezeichnung in der ersten Spalte und ein numerischer Wert in der zweiten, getrennt durch Komma, Tabulator oder Leerzeichen.`)
};

const nl_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén rij per segment: een label in de eerste kolom en een numerieke waarde in de tweede, komma-, tab- of spatiegescheiden.`)
};

const fr_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne par segment : une étiquette dans la première colonne et une valeur numérique dans la seconde, séparées par une virgule, une tabulation ou un espace.`)
};

const it_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga per segmento: un'etichetta nella prima colonna e un valore numerico nella seconda, separati da virgola, tabulazione o spazio.`)
};

const pt_br2_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha por segmento: um rótulo na primeira coluna e um valor numérico na segunda, separados por vírgula, tabulação ou espaço.`)
};

const pt_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha por segmento: um rótulo na primeira coluna e um valor numérico na segunda, separados por vírgula, tabulação ou espaço.`)
};

const ja_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行に1セグメント: 最初の列にラベル、2番目の列に数値をカンマ、タブ、またはスペースで区切って入力します。`)
};

const zh_donut_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行一个分段：第一列为标签，第二列为数值，用逗号、制表符或空格分隔。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_a2", locale)
	if (locale === "en") return en_donut_faq_a2(inputs)
	if (locale === "es") return es_donut_faq_a2(inputs)
	if (locale === "de") return de_donut_faq_a2(inputs)
	if (locale === "nl") return nl_donut_faq_a2(inputs)
	if (locale === "fr") return fr_donut_faq_a2(inputs)
	if (locale === "it") return it_donut_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_a2(inputs)
	if (locale === "pt") return pt_donut_faq_a2(inputs)
	if (locale === "ja") return ja_donut_faq_a2(inputs)
	return zh_donut_faq_a2(inputs)
};